<div class="body">

    <div class="afiliado" *ngIf="rol == 'ROLE_ADMINISTRADOR' || rol == 'ROLE_COORDINADOR' || rol == 'ROLE_CONTABILIDAD' || rol == 'ROLE_ENCARGADO_CONTABILIDAD'">

        <div class="container" style="height:50px"> </div>

        <div class="container">

            <div class="row">

                <div class="col-lg-10"> </div>

                <div class="col-lg-2" *ngIf="rol == 'ROLE_ADMINISTRADOR' ||  rol == 'ROLE_CONTABILIDAD' ||  rol == 'ROLE_ENCARGADO_CONTABILIDAD'">
                    <button class="btn btn-success" (click)="crearProveedor()">

                        <i class="fa fa-plus"></i> Crear Proveedor </button>

                </div>

            </div>

        </div>

        <div class="container" style="height:50px"> </div>

        <div class="container" id="tabla" style="background-color: white; padding-top: 50px; padding-bottom:50px">

            <div class="row">

                <div class="col-lg-6">
                    <h1> Listado de Proveedores </h1>
                </div>

                <div class="col-lg-3"> </div>

                <div class="col-lg-2">
                    <h3> Cantidad de Registros </h3>
                </div>

                <div class="col-lg-1">

                    <select class="form-control">

                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="50">50</option>
                        <option value="100">100</option>

                    </select>
                </div>

            </div>
            <hr /> <br />

            <div class="row">


                <div class="col-lg-2">
                    <h3> RUT de Proveedor: </h3>
                </div>

                <div class="col-lg-3">
                    <form action="#">
                        <input name="txt_rut" class="form-control" id="txt_rut" type="text" #rut="ngModel" [(ngModel)]="buscador.rut" placeholder="Ingrese el RUT (11111111-1)" pattern="[0-9.]{7,10}[-]{1}[0-9Kk]{1}" />
                    </form>
                </div>


                <div class="col-lg-2">
                    <button class="btn btn-info" (click)="buscar()">
                        <i class="fa fa-search" ></i> Buscar </button>
                </div>


            </div> <br /> <br />

            <div class="table-responsive">

                <table class="table">

                    <thead style="background-color: #0f69b4;color:white;">

                        <tr>
                            <th scope="col" style="text-align: center;"> N° </th>

                            <th scope="col" style="text-align: center;"> Rut </th>

                            <th scope="col" style="text-align: center;"> Nombre Corto </th>
                            <th scope="col" style="text-align: center;"> Dirección </th>

                            <th scope="col" style="text-align: center;"> Ciudad </th>
                            <th scope="col" style="text-align: center;"> Región </th>



                            <th scope="col" style="text-align: center;"> Estado </th>
                            <th scope="col" style="text-align: center;"> Activar/Desactivar </th>
                            <th scope="col" style="text-align: center;"> Editar </th>

                            <!--th scope="col" *ngIf="rol != 'ROLE_EJECUTIVO_CAIP' && rol != 'ROLE_ENCARGADO_NACIONAL'"> Activar / Desactivar </!--th -->
                        </tr>

                    </thead>

                    <tbody>

                        <tr [class]="i % 2 == 0 ? 'rowEven' : 'rowOdd'" *ngFor="let proveedor of this.proveedores | paginate: config; let i = index">

                            <td style="text-align: center;">
                                <!--mat-checkbox [(ngModel)]="proveedor.seleccionado" color="primary" (ngModelChange)="updateAllComplete()"> </!--mat-checkbox -->

                                {{proveedor.idProveedor}}</td>
                            <td style="text-align: center;">{{proveedor.rutProveedor}}-{{proveedor.dvProveedor}}</td>
                            <td style="text-align: center;">{{proveedor.nombreCorto}}</td>
                            <td style="text-align: center;">{{proveedor.direccion}}</td>
                            <td style="text-align: center;">{{proveedor.nombreComuna}}</td>

                            <td style="text-align: center;">{{proveedor.nombreRegion}}</td>
                            <td style="text-align: center;" *ngIf="proveedor.estado == 1">ACTIVO</td>
                            <td style="text-align: center;" *ngIf="proveedor.estado == 0">INACTIVO</td>            
                            <td *ngIf="rol == 'ROLE_ADMINISTRADOR' || rol == 'ROLE_CONTABILIDAD' || rol == 'ROLE_ENCARGADO_CONTABILIDAD'"> <button class="btn btn-danger" (click)="modificarEstadoProveedor(proveedor.idProveedor, proveedor.estado)" style="width:120px">
                                <i class="fa fa-pen"> </i> Cambiar Estado
                            </button></td>
                            <td style="text-align: center;"> <button class="btn btn-warning" (click)="editarProveedor(proveedor.idProveedor)">Editar</button></td>

                        </tr>



                    </tbody>

                </table> <br />

                <pagination-controls style="text-align: center" previousLabel="Anterior" nextLabel="Siguiente" (pageChange)="pageChanged($event)" autoHide="true"> </pagination-controls>

            </div>

        </div>

        <div class="container" style="height:100px"> </div>

    </div>



</div>